"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 22.629 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M17.363 14.381a5.674 5.674 0 001.643.258c1.699 0 2.537-.909 2.537-.909 2.278-2.368.266-4.476.266-4.476-.798-.829-1.662-1.068-2.39-1.068-.981 0-1.716.431-1.716.431l-.115.063-.144-.279c.357-.294.518-.709.363-1.011-.185-.36-.748-.422-1.258-.138s-.773.805-.589 1.165c.155.302.577.393 1.01.248l.142.277-1.833 1.01-.139-.268c.357-.294.518-.709.363-1.011-.185-.36-.748-.422-1.258-.138s-.773.806-.589 1.166c.155.302.577.393 1.01.247l.137.267-1.833 1.01-.133-.259c.357-.294.518-.709.363-1.011-.185-.36-.748-.422-1.258-.138s-.773.806-.588 1.165c.155.302.577.393 1.01.247l.132.257-1.833 1.01-.128-.248c.357-.294.518-.709.363-1.011-.185-.36-.748-.422-1.258-.138s-.774.805-.589 1.165c.155.302.577.393 1.01.247l.126.247-1.833 1.01-.122-.238c.357-.294.518-.709.363-1.011-.185-.36-.748-.422-1.258-.138s-.773.806-.589 1.165c.155.302.577.393 1.01.248l.121.236-1.833 1.01-.117-.227c.357-.294.518-.709.363-1.011-.185-.36-.748-.422-1.258-.138s-.773.806-.589 1.166c.155.302.577.393 1.01.247l.116.225-2.391 1.317s1.076 1.487-.612 3.242L0 22.525l3.606 3.748 2.625-2.603c1.597-1.661 3.179-2.051 4.31-2.05.999 0 1.646.303 1.646.303s1.747-2.874 3.127-4.952c1.382-2.08 2.049-2.59 2.049-2.59zm-11.56 3.373a.602.602 0 010-.828.549.549 0 01.796 0c.22.229.22.599 0 .828a.549.549 0 01-.796 0zm2.308-1.357a.613.613 0 010-.843.558.558 0 01.811 0 .613.613 0 010 .843.558.558 0 01-.811 0zm2.342-1.233a.613.613 0 010-.843.558.558 0 01.811 0 .613.613 0 010 .843.56.56 0 01-.811 0zm2.349-1.227a.613.613 0 010-.843.558.558 0 01.811 0 .613.613 0 010 .843.558.558 0 01-.811 0zm2.325-1.324a.613.613 0 010-.843.558.558 0 01.811 0 .613.613 0 010 .843.56.56 0 01-.811 0zm2.331-1.249a.613.613 0 010-.843.558.558 0 01.811 0 .613.613 0 010 .843.558.558 0 01-.811 0z" })));
};
var SvgHeadstockFill45C = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgHeadstockFill45C;
var templateObject_1;
